export const EXCLUSIVE_CAROUSEL = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ExclusiveCarouselElement';
